import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { CopyToClipboardWrapper } from '../buttons/copyToClipboardButton';
import { CellActionsWrapper } from '../table/cellActionsWrapper';
import { OverflowTooltip } from '../tooltips/overflowTooltip';
const TruncatedText = t0 => {
  const $ = _c(7);
  const {
    text,
    maxWidth
  } = t0;
  let t1;
  if ($[0] !== maxWidth) {
    t1 = {
      overflow: "hidden",
      maxWidth
    };
    $[0] = maxWidth;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text) {
    t2 = <OverflowTooltip text={text} renderContent={_temp} />;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Stack sx={t1}>{t2}</Stack>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};

/** Table-column width: cells share the row with other columns. */
const CELL_MAX_WIDTH = '280px';

/** Detail-panel width: a field owns the full panel row. */
const FIELD_MAX_WIDTH = '530px';
export const TruncatedCellText = t0 => {
  const $ = _c(5);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = <TruncatedText text={text} maxWidth={CELL_MAX_WIDTH} />;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== text) {
    t2 = <CellActionsWrapper textToCopy={text}>{t1}</CellActionsWrapper>;
    $[2] = t1;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const TruncatedFieldText = t0 => {
  const $ = _c(5);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = <TruncatedText text={text} maxWidth={FIELD_MAX_WIDTH} />;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== text) {
    t2 = <CopyToClipboardWrapper textToCopy={text}>{t1}</CopyToClipboardWrapper>;
    $[2] = t1;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(content, ref) {
  return <Typography className="truncate" ref={ref}>{content}</Typography>;
}